export default __webpack_public_path__ + "static/media/logo-smart-chat-blank.0121951d.png";